import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const chipLabelSx = {
  display: "block",
  textAlign: "center",
  px: 1,
  py: 0.5,
};

const chipBaseSx = {
  minWidth: "90px",
  textAlign: "center",
  borderRadius: 0,
  fontWeight: 600,
  fontSize: "0.75rem",
  border: "none",
  "& .MuiChip-label": chipLabelSx,
};

export function getIntegratedEvidenceApprovalChipProps(approvalStatus, theme) {
  const { success, error, info } = theme.customColors.status;
  let bg;
  let color;
  let label;
  if (approvalStatus === "approved") {
    label = "Approved";
    bg = success.bg;
    color = success.text;
  } else if (approvalStatus === "rejected") {
    label = "Rejected";
    bg = error.bg;
    color = error.text;
  } else {
    label = "Pending";
    bg = info.bg;
    color = info.text;
  }
  return {
    label,
    sx: { ...chipBaseSx, backgroundColor: bg, color },
  };
}

/** Shared: entity detail, check suggestions table, AI evidence home table. */
export function IntegratedEvidenceApprovalStatusChip({ approvalStatus }) {
  const theme = useTheme();
  const { label, sx } = getIntegratedEvidenceApprovalChipProps(approvalStatus, theme);
  return <Chip label={label} sx={sx} />;
}
